const SexualOrientation = [{SexualOrientationDescription: 'Decline to Answer', SexualOrientationID: 1}, 
{SexualOrientationDescription: 'Heterosexual ', SexualOrientationID: 2},
{SexualOrientationDescription: 'Gay', SexualOrientationID: 3},
{SexualOrientationDescription: 'Lesbian', SexualOrientationID: 4},
{SexualOrientationDescription: 'Bisexual', SexualOrientationID: 5}];

export default SexualOrientation;